import React, { createContext, useContext } from "react"
import { Layout } from "../../../Types/Layout"
import { MobergDropdown, MobergDropdownValue } from "../../../../../../../Components/MobergDropdown/MobergDropdown"
import { VisualizationComponent } from "../../../VisualizationComponent"
import { EnvironmentVariables, useEnvironmentVariablesProvider } from "../../../../../../../Providers/EnvironmentVariablesProvider"

type VisualizationSelectorContextProps = {
	currentLayoutId: string
	selectedLayout: Layout | undefined
	updateSelectedLayout(layout: Layout): void
}

export const VisualizationSelectorContext = createContext<VisualizationSelectorContextProps>({} as VisualizationSelectorContextProps)

export type VisualizationSelectorProps = {
	windowId: string
}

export const VisualizationSelector = (props: VisualizationSelectorProps) => {
	const { environmentVariables } = useEnvironmentVariablesProvider()
	const { selectedLayout, updateSelectedLayout } = useContext(VisualizationSelectorContext)
	const window = selectedLayout?.areas.find(window => window.area === props.windowId)

	const ALL_OPTIONS: { componentId: VisualizationComponent, label: string, featureFlag?: keyof EnvironmentVariables }[] = [
		{ componentId: VisualizationComponent.EEG_MONTAGE, label: "EEG Montage" },
		{ componentId: VisualizationComponent.TIME_SERIES_GROUP, label: "Time Series Group" },
		{ componentId: VisualizationComponent.PERSYST_TRENDS, label: "Persyst Trends", featureFlag: "FEATURE_FLAG_PERSYST" },
		{ componentId: VisualizationComponent.PERSYST_EEG, label: "Persyst EEG", featureFlag: "FEATURE_FLAG_PERSYST" },
		{ componentId: VisualizationComponent.CPPOPT_PLOT, label: "CPPopt Plot", featureFlag: "FEATURE_FLAG_CPPOPT" },
		{ componentId: VisualizationComponent.MAPOPT_PLOT, label: "MAPopt Plot", featureFlag: "FEATURE_FLAG_MAPOPT" },
		{ componentId: VisualizationComponent.HISTOGRAM, label: "Histogram", featureFlag: "FEATURE_FLAG_HISTOGRAM" },
		{ componentId: VisualizationComponent.SCATTER_PLOT, label: "Scatter Plot", featureFlag: "FEATURE_FLAG_SCATTER_PLOT" },
		{ componentId: VisualizationComponent.SD_DETECTION, label: "SD Detection", featureFlag: "FEATURE_FLAG_SD_DETECTION" },
		{ componentId: VisualizationComponent.EVENT_REVIEW, label: "Event Review", featureFlag: "FEATURE_FLAG_EVENT_REVIEW" },
	]

	const options = ALL_OPTIONS
		.filter(o => !o.featureFlag || environmentVariables[o.featureFlag])
		.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))

	const selectedWindowType = window?.componentId ?? VisualizationComponent.PLACEHOLDER

	function handleClick(componentId: MobergDropdownValue) {

		if (!selectedLayout) {
			return
		}

		const updatedLayout = {
			...selectedLayout,
			areas: selectedLayout?.areas.map(window => {
				if (window.area === props.windowId) {
					return {
						area: window.area,
						componentId: componentId as string,
						props: {}
					}
				}
				return window
			})
		}

		updateSelectedLayout(updatedLayout)
	}

	return (
		<div
			style={{
				display: "flex",
				border: "1px solid #dedede",
				borderRadius: "10px",
				alignItems: "center",
				justifyContent: "center",
				width: "100%",
				height: "100%",
				gap: "10px",
			}}
		>
			<MobergDropdown
				selectedValue={selectedWindowType}
				onChange={handleClick}
				options={options.map(option => ({ label: option.label, value: option.componentId }))}
				dataTestId="window-type-select"
			/>

		</div>
	)
}
